import Warning from '@mui/icons-material/Warning'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'

import { useActions } from '../hooks/useActions'
import { useController } from '../hooks/useController'
import { useTexts } from '../useTexts'

export function DiscardConfirmDialog() {
  const texts = useTexts()
  const {
    data: { showDiscardConfirm, discarding },
  } = useController()
  const { cancelDiscard, confirmDiscard } = useActions()

  return (
    <Dialog
      open={showDiscardConfirm}
      onClose={discarding ? undefined : cancelDiscard}
      PaperProps={{ sx: { borderRadius: 1, width: 574, maxWidth: 574 } }}
    >
      <DialogTitle sx={{ pt: 3, px: 4, pb: 2 }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Warning color="error" />
          <Typography variant="h6">{texts.discardConfirmTitle}</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ px: 4, py: '20px' }}>
        <Typography variant="body1">{texts.discardConfirmBody}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 4, pt: 1, pb: 3 }}>
        <Button onClick={cancelDiscard} variant="outlined" disabled={discarding}>
          {texts.discardConfirmKeep}
        </Button>
        <Button
          onClick={confirmDiscard}
          variant="contained"
          color="error"
          disabled={discarding}
          data-testid="build-progress__discard-confirm"
        >
          {texts.discardConfirmConfirm}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
